import React from "react";

const Banner = () => {
  return (
    <div className="mx-12">
      <div className="w-100  my-12">
        <img
          className="w-full"
          src="https://i.ibb.co/JQrY4Zk/handymand-service-banner-with-black-white-tools-seamless-pattern-125540-929.webp"
          alt=""
        />
      </div>
    </div>
  );
};

export default Banner;
